import { render, staticRenderFns } from "./FtaInfoLine.vue?vue&type=template&id=13ee453c&scoped=true"
import script from "./FtaInfoLine.vue?vue&type=script&lang=js"
export * from "./FtaInfoLine.vue?vue&type=script&lang=js"
import style0 from "./FtaInfoLine.vue?vue&type=style&index=0&id=13ee453c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ee453c",
  null
  
)

export default component.exports